export default __webpack_public_path__ + "4e5029791fdd836d2a4eaa2406e8b37e.png";